var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#FAF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 12.5418C12.2995 12.5418 12.542 12.2993 12.542 12.0002C12.542 11.701 12.2995 11.4585 12.0003 11.4585C11.7012 11.4585 11.4587 11.701 11.4587 12.0002C11.4587 12.2993 11.7012 12.5418 12.0003 12.5418Z",
    stroke: "#A855F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.792 12.5418C16.0911 12.5418 16.3337 12.2993 16.3337 12.0002C16.3337 11.701 16.0911 11.4585 15.792 11.4585C15.4928 11.4585 15.2503 11.701 15.2503 12.0002C15.2503 12.2993 15.4928 12.5418 15.792 12.5418Z",
    stroke: "#A855F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20866 12.5418C8.50781 12.5418 8.75033 12.2993 8.75033 12.0002C8.75033 11.701 8.50781 11.4585 8.20866 11.4585C7.9095 11.4585 7.66699 11.701 7.66699 12.0002C7.66699 12.2993 7.9095 12.5418 8.20866 12.5418Z",
    stroke: "#A855F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.6a1b2e3cf0da11437ad07e9abcfcf9e1.svg";
export { ForwardRef as ReactComponent };